"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: feature/feature-extensions.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ffeature%2Ffeature-extensions.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureCascadeToJSON = exports.featureCascadeFromJSON = exports.FeatureExtension = exports.FeatureCascade = void 0;
const feature_applicability_setting_1 = require("./feature-applicability-setting");
const protobufPackage = 'com.step.feature.proto';
var FeatureCascade;
(function (FeatureCascade) {
    FeatureCascade["INVALID_FEATURE_CASCADE"] = "INVALID_FEATURE_CASCADE";
    FeatureCascade["NONE"] = "NONE";
    FeatureCascade["FAMILY"] = "FAMILY";
    FeatureCascade["FAMILY_INVITE"] = "FAMILY_INVITE";
    FeatureCascade["REFERRAL"] = "REFERRAL";
    FeatureCascade["UNRECOGNIZED"] = "UNRECOGNIZED";
})(FeatureCascade || (exports.FeatureCascade = FeatureCascade = {}));
function createBaseFeatureExtension() {
    return {
        title: '',
        applicable: feature_applicability_setting_1.FeatureApplicabilitySetting.INVALID_FEATURE_APPLICABILITY_CONFIG,
        cascade: FeatureCascade.INVALID_FEATURE_CASCADE,
        hiddenFromAdmin: false,
        seed: '',
        variantSeed: '',
        removedInSdkVersion: '',
    };
}
exports.FeatureExtension = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.title)) {
            message.title = globalThis.String(object.title);
        }
        if (isSet(object.applicable)) {
            message.applicable = (0, feature_applicability_setting_1.featureApplicabilitySettingFromJSON)(object.applicable);
        }
        if (isSet(object.cascade)) {
            message.cascade = featureCascadeFromJSON(object.cascade);
        }
        if (isSet(object.hiddenFromAdmin)) {
            message.hiddenFromAdmin = globalThis.Boolean(object.hiddenFromAdmin);
        }
        if (isSet(object.seed)) {
            message.seed = globalThis.String(object.seed);
        }
        if (isSet(object.variantSeed)) {
            message.variantSeed = globalThis.String(object.variantSeed);
        }
        if (isSet(object.removedInSdkVersion)) {
            message.removedInSdkVersion = globalThis.String(object.removedInSdkVersion);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== undefined && message.title !== '') {
            obj.title = message.title;
        }
        if (message.applicable !== undefined &&
            message.applicable !== feature_applicability_setting_1.FeatureApplicabilitySetting.INVALID_FEATURE_APPLICABILITY_CONFIG) {
            obj.applicable = (0, feature_applicability_setting_1.featureApplicabilitySettingToJSON)(message.applicable);
        }
        if (message.cascade !== undefined && message.cascade !== FeatureCascade.INVALID_FEATURE_CASCADE) {
            obj.cascade = featureCascadeToJSON(message.cascade);
        }
        if (message.hiddenFromAdmin !== undefined && message.hiddenFromAdmin !== false) {
            obj.hiddenFromAdmin = message.hiddenFromAdmin;
        }
        if (message.seed !== undefined && message.seed !== '') {
            obj.seed = message.seed;
        }
        if (message.variantSeed !== undefined && message.variantSeed !== '') {
            obj.variantSeed = message.variantSeed;
        }
        if (message.removedInSdkVersion !== undefined && message.removedInSdkVersion !== '') {
            obj.removedInSdkVersion = message.removedInSdkVersion;
        }
        return obj;
    },
    create(base) {
        return exports.FeatureExtension.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureExtension();
        message.title = object.title ?? '';
        message.applicable = object.applicable ??
            feature_applicability_setting_1.FeatureApplicabilitySetting.INVALID_FEATURE_APPLICABILITY_CONFIG;
        message.cascade = object.cascade ?? FeatureCascade.INVALID_FEATURE_CASCADE;
        message.hiddenFromAdmin = object.hiddenFromAdmin ?? false;
        message.seed = object.seed ?? '';
        message.variantSeed = object.variantSeed ?? '';
        message.removedInSdkVersion = object.removedInSdkVersion ?? '';
        return message;
    },
};
function featureCascadeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FEATURE_CASCADE':
            return FeatureCascade.INVALID_FEATURE_CASCADE;
        case 1:
        case 'NONE':
            return FeatureCascade.NONE;
        case 2:
        case 'FAMILY':
            return FeatureCascade.FAMILY;
        case 3:
        case 'FAMILY_INVITE':
            return FeatureCascade.FAMILY_INVITE;
        case 4:
        case 'REFERRAL':
            return FeatureCascade.REFERRAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FeatureCascade.UNRECOGNIZED;
    }
}
exports.featureCascadeFromJSON = featureCascadeFromJSON;
function featureCascadeToJSON(object) {
    switch (object) {
        case FeatureCascade.INVALID_FEATURE_CASCADE:
            return 'INVALID_FEATURE_CASCADE';
        case FeatureCascade.NONE:
            return 'NONE';
        case FeatureCascade.FAMILY:
            return 'FAMILY';
        case FeatureCascade.FAMILY_INVITE:
            return 'FAMILY_INVITE';
        case FeatureCascade.REFERRAL:
            return 'REFERRAL';
        case FeatureCascade.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.featureCascadeToJSON = featureCascadeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=feature-extensions.js.map